import { createAsyncThunk } from '@reduxjs/toolkit'
import axios, { AxiosError } from 'axios'
import { ISigninFormProps, ISignupFormProps } from '../../../interfaces/account/signup'
// import { ISigninFormProps } from '../../../interfaces/account/signin'
// import { SaveTokenInIndexedDB } from '../../../utils/indexedDBUtils/save-index-db'
// import { DeleteTokenInIndexDB } from '../../../utils/indexedDBUtils/delete-index-db'
import { ErrorResponse } from '../../../interfaces/common-apis/i-error'
import { getAPIConfig } from './services/get-api-config'
import { ApiEndPoints } from './api-path'
import { SaveTokenInIndexedDB } from '../../../utils/indexedDBUtils/save-index-db'

// this is signup api
/**
 * @description This method makes an api call for create a organisation account signup
 */
export const signup = createAsyncThunk(
  'auth/signup',
  async (values: ISignupFormProps, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.AuthSignup}`;
      const { data } = await axios.post(url, values, await getAPIConfig())

      if (data.status === 201) {
        return thunkApi.fulfillWithValue(data)
      }
    } catch (e) {
      const error = e as AxiosError<ErrorResponse>
      if (error.response) {
        return thunkApi.rejectWithValue(error.response)
      } else {
        return thunkApi.rejectWithValue('An unknown error occurred.')
      }
    }
  }
)

/**
 * @description This method makes an API call to check if the username is available
*/
export const checkUsername = createAsyncThunk(
  'auth/checkUsername',
  async (username: string, thunkApi) => {
    try {// Replace with the correct API endpoint
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.AuthUsername}`;
      const { data } = await axios.post(url, { username }); // POST request with the username

      if (data.status === 200 && data.available === true) {
        return thunkApi.fulfillWithValue(data); // Username is available
      }
    } catch (e) {
      const error = e as AxiosError<ErrorResponse>;
      if (error.response) {
        return thunkApi.rejectWithValue(error.response.data); // Handle error response from API
      } else {
        return thunkApi.rejectWithValue('An unknown error occurred.');
      }
    }
  }
);

// this api is for confirm Account
/**
 * @description This method makes an api call for confirmAccount through the change password
*/
export const confirmAccount: any = createAsyncThunk(
  'auth/confirmAccount',
  async (values, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.AuthConfirm}`;
      const { data } = await axios.post(url, values, await getAPIConfig())

      if (data.status === 201) {
        return thunkApi.fulfillWithValue(data)
      }
    } catch (e) {
      const error = e as AxiosError<ErrorResponse>
      if (error.response) {
        return thunkApi.rejectWithValue(error.response)
      } else {
        return thunkApi.rejectWithValue('An unknown error occurred.')
      }
    }
  }
)

// this is signin api
/**
 * @description This method makes an api call for account signin
*/

export const signin = createAsyncThunk(
  'auth/signin',
  async (values: ISigninFormProps, thunkAPI) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.AuthSignin}`;
      const { data } = await axios.post(url, values, await getAPIConfig())
      if (data.status === 200) {
        await SaveTokenInIndexedDB(data.token, 'authToken')
        return thunkAPI.fulfillWithValue(data)
      }
    } catch (e) {
      const error = e as AxiosError<ErrorResponse>
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response)
      } else {
        return thunkAPI.rejectWithValue('An unknown error occurred.')
      }
    }
  }
)

/**
 * @description This method makes an api call for verifyEmail
 */
export const verifyEmail: any = createAsyncThunk(
  'auth/verifyEmail',
  async (values, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.AuthConfirmEmail}`
      const { data } = await axios.post(url, values, await getAPIConfig())
      if (data.status === 200) {
        return thunkApi.fulfillWithValue(data)
      }
    } catch (e) {
      const error = e as AxiosError<ErrorResponse>
      if (error.response) {
        return thunkApi.rejectWithValue(error.response)
      } else {
        return thunkApi.rejectWithValue('An unknown error occurred.')
      }
    }
  }
)

/**
 * @description This method makes an api call for verify otp for change password
 */
export const verificationAccount: any = createAsyncThunk(
  'auth/verificationAccount',
  async (values, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.AuthVerifyaccount}`
      const { data } = await axios.post(url, values, await getAPIConfig())
      if (data.status === 200) {
        return thunkApi.fulfillWithValue(data)
      }
    } catch (e) {
      const error = e as AxiosError<ErrorResponse>
      if (error.response) {
        return thunkApi.rejectWithValue(error.response)
      } else {
        return thunkApi.rejectWithValue('An unknown error occurred.')
      }
    }
  }
)

/**
 * @description This method makes an api call for forget password create new password
 */
export const createNewPassword: any = createAsyncThunk(
  'auth/createNewPassword',
  async (values, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.CreateNewPass}`
      const { data } = await axios.post(url, values, await getAPIConfig())
      if (data.status === 200) {
        return thunkApi.fulfillWithValue(data)
      }
    } catch (e) {
      const error = e as AxiosError<ErrorResponse>
      if (error.response) {
        return thunkApi.rejectWithValue(error.response)
      } else {
        return thunkApi.rejectWithValue('An unknown error occurred.')
      }
    }
  }
)

// this is forgetPassword api
/**
 * @description This method makes an api call for forgetPassword
 */
// export const forgetPassword: any = createAsyncThunk(
//   'auth/forgetPassword',
//   async (values, thunkApi) => {
//     try {
//       const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.AuthConfirmPassword}`
//       const { data } = await axios.post(url, values, await getAPIConfig())
//       if (data) {
//         return thunkApi.fulfillWithValue(data)
//       }
//     } catch (e) {
//       const error = e as AxiosError<ErrorResponse>
//       if (error.response) {
//         return thunkApi.rejectWithValue(error.response)
//       } else {
//         return thunkApi.rejectWithValue('An unknown error occurred.')
//       }
//     }
//   }
// )


/**
 * @description This method makes an api call for set the Default Schools
 */
// export const setDefaultSchool: any = createAsyncThunk(
//   'user/setDefaultSchool',
//   async (values, thunkApi) => {
//     try {
//       const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.SetDefaultSchool}`
//       const { data } = await axios.get(url, await getAPIConfig())
//       if (data) {
//         return thunkApi.fulfillWithValue(data)
//       }
//     } catch (e) {
//       const error = e as AxiosError<ErrorResponse>
//       if (error.response) {
//         return thunkApi.rejectWithValue(error.response)
//       } else {
//         return thunkApi.rejectWithValue('An unknown error occurred.')
//       }
//     }
//   }
// )

/**
 * @description This method makes an api call for set the Default Schools
 */
// export const getAuthData: any = createAsyncThunk(
//   'user/getAuthData',
//   async (values, thunkApi) => {
//     try {
//       const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.GetAuthData}`
//       const { data } = await axios.get(url, await getAPIConfig())
//       if (data) {
//         return thunkApi.fulfillWithValue(data)
//       }
//     } catch (e) {
//       const error = e as AxiosError<ErrorResponse>
//       if (error.response) {
//         return thunkApi.rejectWithValue(error.response)
//       } else {
//         return thunkApi.rejectWithValue('An unknown error occurred.')
//       }
//     }
//   }
// )

/**
 * @description This method makes an api call get all sessions
 */
// export const GetAllFinancialYear: any = createAsyncThunk(
//   'auth/getAllFinancialYear',
//   async (values, thunkApi) => {
//     try {
//       const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.GerAllFinancialYears}`
//       const { data } = await axios.get(url, await getAPIConfig())
//       if (data) {
//         return thunkApi.fulfillWithValue(data)
//       }
//     } catch (e) {
//       const error = e as AxiosError<ErrorResponse>
//       if (error.response) {
//         return thunkApi.rejectWithValue(error.response)
//       } else {
//         return thunkApi.rejectWithValue('An unknown error occurred.')
//       }
//     }
//   }
// )

// this is signout api
/**
 * @description This method is account for signout
 */
// export const signout = createAsyncThunk(
//   'auth/signout',
//   async (values: boolean, thunkApi) => {
//     try {
//       // here we will use the DeleteTokenInIndexDB this method for delete the authToken from indexDB.
//       if (values === true) {
//         await DeleteTokenInIndexDB('authToken')
//         await DeleteTokenInIndexDB('refreshToken')
//       }
//     } catch (e) {
//       const error = e as AxiosError<ErrorResponse>
//       if (error.response) {
//         return thunkApi.rejectWithValue(error.response)
//       } else {
//         return thunkApi.rejectWithValue('An unknown error occurred.')
//       }
//     }
//   }
// )

// this is authorizeToken api
/**
 * @description This method sets jwt token set with user's cookie as current user
 */
// export const authorizeToken: any = createAsyncThunk(
//   'auth/authorizeToken',
//   async (values, thunkApi) => {
//     try {
//       return thunkApi.fulfillWithValue(values)
//     } catch (e) {
//       const error = e as AxiosError<ErrorResponse>
//       if (error.response) {
//         return thunkApi.rejectWithValue(error.response)
//       } else {
//         return thunkApi.rejectWithValue('An unknown error occurred.')
//       }
//     }
//   }
// )
